import { FC } from 'react';
import { Navbar } from 'src/shared';
import { RootBox } from './styled';

const Bugs: FC = () => {
    return (
        <Navbar>
            <RootBox></RootBox>
        </Navbar>
    );
};

export default Bugs;
